import { FC, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'

import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { Button } from '@src/components/Button/Button'
import { selectUserInfo, selectUserSumToPay } from '@src/store/ducks/user/selectors'
import { validateForm } from '@src/messages/validateForm'
import { getPaymentUrl } from '@src/store/ducks/pay/thunks'
import { AppDispatch } from '@src/store/store'
import style from '@src/components/PaymentForm/PaymentForm.module.scss'
import cn from 'classnames'

const validationSchema = Yup.object().shape({
  sum: Yup.number()
    .typeError('Сумма должно быть числом')
    .required(validateForm.required)
    .test('min', 'Сумма должна быть положительным', (val) => !!val && val > 0)
    .test('max', 'Сумма должна быть не больше 199.99р', (val) => !!val && val < 200),
})

type PaymentFormProps = {
  sum?: number
  payId?: string | null
}

export const PaymentForm: FC<PaymentFormProps> = ({ sum, payId }) => {
  const dispatch = useDispatch<AppDispatch>()
  const sumToPay = useSelector(selectUserSumToPay)
  const user = useSelector(selectUserInfo)

  const initialValues = useMemo(() => ({
    sum: sum || sumToPay,
    isReccurent: false,
    payId,
  }), [sumToPay, sum])

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        dispatch(getPaymentUrl(values.sum, values.isReccurent, values.payId))
      }}
      enableReinitialize
    >
      {({ setFieldValue, values }) => (
        <Form className={style.formContainer}>
          <div className={style.title}>Пополнение баланса</div>
          <div className={style.firstBlock}>
            <FieldFormik className={style.size} name="sum" placeholder="Сумма платежа" />
            <Button htmlType="submit" type="primary">Пополнить счёт</Button>
          </div>
          <div className={style.secondBlock}>
            <div className={style.autopay}>
              <div>Включить автоплатёж</div>
              <label className={style.switch}>
                <input
                  type="checkbox"
                  name="isReccurent"
                  checked={values.isReccurent}
                  onChange={() => { setFieldValue('isReccurent', !values.isReccurent) }}
                />
                <span className={cn(style.slider, style.round)} />
              </label>
            </div>
            {!user.isSubscriber && (
              <div className={style.anotherPayment}>
                <a href={`${process.env.REACT_APP_SITE_URL}/clients/payment`}>
                  Другие способы оплаты
                </a>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  )
}
